import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const salesTargetService = {
  getAllSalesTargets, getSalesTarget, createSalesTarget, updateSalesTarget,
  deleteSalesTarget, getMyProgress, getAllProgress, getByAgent, getAgentDetail,
  getMonthlySummary,
}

const API_URL = API.BASE_URL + '/v1'

function buildParams(filter) {
  const params = { per_page: filter?.pageSize, page: filter?.pageNumber }
  if (filter?.agentCode) params.agent_code = filter.agentCode
  if (filter?.periodType) params.period_type = filter.periodType
  if (filter?.year) params.year = filter.year
  return params
}

export function getAllSalesTargets(filter) {
  return apiHelper(API_URL).get('/sales-targets', { params: buildParams(filter) })
}
export function getSalesTarget(id) {
  return apiHelper(API_URL).get(`/sales-targets/${id}`)
}
export function createSalesTarget(data) {
  return apiHelper(API_URL).post('/sales-targets', data)
}
export function updateSalesTarget(id, data) {
  return apiHelper(API_URL).put(`/sales-targets/${id}`, data)
}
export function deleteSalesTarget(id) {
  return apiHelper(API_URL).delete(`/sales-targets/${id}`)
}
export function getMyProgress() {
  return apiHelper(API_URL).get('/sales-targets/my-progress')
}
export function getAllProgress(params) {
  return apiHelper(API_URL).get('/sales-targets/all-progress', { params })
}
export function getByAgent() {
  return apiHelper(API_URL).get('/sales-targets/by-agent')
}
export function getAgentDetail(agentCode) {
  return apiHelper(API_URL).get(`/sales-targets/agent/${encodeURIComponent(agentCode)}`)
}
export function getMonthlySummary(year) {
  return apiHelper(API_URL).get('/sales-targets/monthly-summary', { params: year ? { year } : {} })
}
